// extracted by mini-css-extract-plugin
module.exports = {"isSuccess":"BuyerRequestRecommendedSellersButton_isSuccess__3__YX typeography_ui12SemiBold__3xcry"};